import { ReactElement, useEffect } from "react";
import { decodeJwt, decodeJwtHeader } from "../utils/decodeJwt";
import { Splash } from "../components/atoms/InnerPage/Splash";
import { useAtom } from "jotai";
import {
  accessTokenAtom,
  accessTokenInfoAtom,
  companyAccessTokenAtom,
  queryLoginDataParamAtom,
  recTypeAtom,
  showLoginAlertDialogAtom,
} from "../store";
import { useSetSetting } from "../utils/setting";
import dayjs from "dayjs";
import { InvalidTokenError } from "jwt-decode";
import { AccessToken } from "../types";

/*
 * クエリログイン
 */
export function QueryLogin(): ReactElement {
  const [company_token] = useAtom(companyAccessTokenAtom);
  const [, setLoginData] = useAtom(queryLoginDataParamAtom);
  const [, setAccessToken] = useAtom(accessTokenAtom);
  const [, setRecType] = useAtom(recTypeAtom);
  const [showDialog] = useAtom(showLoginAlertDialogAtom);
  const [accessTokenInfo] = useAtom(accessTokenInfoAtom);
  const setSettingInfo = useSetSetting();
  const [, setAccessTokenInfo] = useAtom(accessTokenInfoAtom);

  useEffect(() => {
    if (!company_token) return;

    let companyId, employeeId, recType;
    let companyAccessToken: string | undefined;
    let companyExpiresIn: number | undefined;

    try {
      const objCompanyAccessTokenInfo = JSON.parse(company_token);
      const decodedHeader = decodeJwtHeader(
        objCompanyAccessTokenInfo.access_token,
      );

      if (decodedHeader && decodedHeader.typ === "JWT") {
        companyAccessToken = objCompanyAccessTokenInfo.access_token as string;
        companyExpiresIn = objCompanyAccessTokenInfo.expires_in as number;

        // FIXME: Core API にクエリログインが未実装。
        // decodeJwt の戻り値型は Core API の型定義に基づいており、
        // クエリログイン専用クレーム（companyEmail / employeeEmail / recType）が含まれないため
        // as any で型エラーを回避している。Core 実装後に型定義ごと見直すこと。
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const decoded = decodeJwt(companyAccessToken) as unknown as any;
        if (decoded) {
          companyId = decoded.companyEmail;
          employeeId = decoded.employeeEmail;
          recType = decoded.recType;
        }
      }
    } catch (err) {
      if (err instanceof InvalidTokenError) {
        console.log(`decode error. ${err.message}`);
        return;
      }
      if (err instanceof Error) {
        console.log(`Runtime error. ${err.message}`);
        return;
      }
    }

    if (!companyId || !employeeId || !companyAccessToken || !companyExpiresIn) {
      console.error("company_tokenが異常な形式です");
      return;
    }

    const queryLoginUserData = {
      companyId,
      companyAccessToken,
      employeeId,
      recType,
    };

    // ここからログイン処理実装
    setLoginData(queryLoginUserData);
    if (queryLoginUserData?.recType) {
      setRecType(queryLoginUserData.recType);
    }

    // FIXME: Core API にクエリログインが未実装のため仮置き。
    setAccessToken(companyAccessToken);
    const token = {
      user_id: employeeId, // email形式のため正しくない
      company_id: companyId, // email形式のため正しくない
      access_token: companyAccessToken,
      expired_at: dayjs().add(companyExpiresIn, "second").toISOString(),
    } as AccessToken;

    setAccessTokenInfo(token);
    if (!showDialog) {
      setSettingInfo(token);
    }
  }, [
    setAccessTokenInfo,
    setSettingInfo,
    company_token,
    setAccessToken,
    showDialog,
    setLoginData,
    setRecType,
  ]);

  return <>{accessTokenInfo && <Splash />}</>;
}
